import { render } from "./holding-deletion-modal.vue?vue&type=template&id=19b11bba"
import script from "./holding-deletion-modal.vue?vue&type=script&lang=js"
export * from "./holding-deletion-modal.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__